

























import Vue from 'vue'

export default Vue.extend({
  computed: {
    breadcrumbs() {
      // TOPは必ず含める
      return [{ name: 'TOP', path: '/' }, ...this.$breadcrumbs.get()]
    },
  },
})
